import { FC } from 'react'
import { UseFormReturn } from 'react-hook-form'

import { Eye, EyeOff } from 'lucide-react'
import { GroupFormType } from '../GroupForm/utils'
import { VisibilityOptions } from '@wellesley/forms'
import SelectWithRadio from 'components/form/SelectWithRadio'

const visibilitySelect = [
  {
    key: VisibilityOptions.visible,
    description: `Listed publicly and searchable by user`,
    icon: <Eye />,
  },
  {
    key: VisibilityOptions.unlisted,
    description: `Hidden from group listings and search results`,
    icon: <EyeOff />,
  },
]

type CmpProps = {
  form: UseFormReturn<GroupFormType>
  title: string
  disabled?: boolean
}

const VisibilitySelect: FC<CmpProps> = ({ form, title, disabled }) => {
  return (
    <SelectWithRadio
      form={form}
      name="visibility"
      title={title}
      options={visibilitySelect}
      className="mb-xl"
      disabled={disabled}
    />
  )
}

export default VisibilitySelect
